<template>
  <div class="form-wrapper">
    <v-form v-model="valid">
      <!-- <v-form @submit="login"> -->
      <h2>Login</h2>
      <v-row>
        <v-text-field
          v-model="credentials.userNameOrEMail"
          :rules="usernameRules"
          id="username"
          label="Username"
        >
        </v-text-field>
      </v-row>

      <v-row>
        <v-text-field
          v-model="credentials.password"
          id="password"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="passwordRules"
          :type="show1 ? 'text' : 'password'"
          label="Password"
          counter
          @click:append="show1 = !show1"
        >
        </v-text-field>
      </v-row>
      <v-row class="form-actions-container">
        <p v-if="!loading">
          <v-btn
          :disabled="!valid"
            @click="login"
            class="form-actions first-action"
            >Login</v-btn
          >
        </p>
        <SmallLoaderLight class="form-loader" v-if="loading" />
      </v-row>
    </v-form>
    <div class="form-error-container">
      <Alert
        v-if="error"
        :message="error"
        type="error"
        :handle-click="cleanError"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SmallLoaderLight from "@/components/atoms/SmallLoaderLight";
import Alert from "@/components/atoms/Alert";

export default {
  components: {
    SmallLoaderLight,
    Alert,
  },
  data() {
    return {
      valid: false,
      show1: false,
      loading: false,
      usernameRules: [
        (v) => !!v || "Username is required",
        (v) => v.length >= 4 || "Name must be more than 4 characters",
        (v) => v.length < 150 || "Name must be less than 150 characters",
      ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length > 7 || "Password must be minimum 8 characters",
      ],
      credentials: {
        userNameOrEMail: "",
        password: "",
      },
    };
  },
  methods: {
    async login() {
      this.$store.commit("RESET_LOGIN_ERROR");
      this.loading = true;
      const success = await this.$store.dispatch("login", this.credentials);

      if (success) {
        this.$router.push("/").catch(() => {});
        await this.$store.dispatch("getTypes");
        await this.$store.dispatch("getMiscellaneous");
        await this.$store.dispatch("getGames");
        await this.$store.dispatch("getProfiles");
        await this.$store.dispatch("getOwnProfile");
        await this.$store.dispatch("getNotifications");
      }
      this.loading = false;
    },
    cleanError() {
      this.$store.commit("RESET_LOGIN_ERROR");
    },
  },
  computed: mapState({
    error: (state) => state.errors.login,
    validCredentials: function () {
      return this.credentials.userNameOrEMail && this.credentials.password;
    },
  }),
  mounted() {
    this.$store.commit("RESET_LOGIN_ERROR");
  },
};
</script>
